import { fg } from '@atlaskit/platform-feature-flags';
import { fetchAgg } from '../../../../common/utils/fetch-agg';
import { operationName, quickFindRecentActivitiesQuery } from './query';
export var recentActivitiesQuery = function recentActivitiesQuery(_ref) {
  var variables = _ref.variables,
    aggAbsoluteUrl = _ref.aggAbsoluteUrl;
  var is3PEnabled = fg('quick_find_enable_3p_activity');
  return fetchAgg({
    variables: variables,
    aggAbsoluteUrl: aggAbsoluteUrl,
    graphQuery: quickFindRecentActivitiesQuery(is3PEnabled),
    operationName: operationName
  });
};